export default __webpack_public_path__ + "static/ti_bike_block-a77e3a946b35354a17d507aa92ea9d9f.svg";